import React from "react";
import { Link } from "react-router-dom";

function NavBar() {

    return(
        <div className="bg-darkBlue">
            <nav className="h-16 bg-darkBlue text-white font-semibold items-center max-w-[1400px] mx-auto px-10">

            <ul className="flex gap-7 py-4">
            <img src="https://thumbs.dreamstime.com/b/netflix-logo-editorial-word-vector-online-movies-netflix-logo-illustration-blue-background-streaming-service-app-netflix-logo-158825235.jpg" className="logo-img mx-3 w-14 py-1" alt="logo" />

    <Link to="/">
        Home
    </Link>
    <Link to="/movies">
        Movies
    </Link>
    <Link to="/tv-shows">
        TV Shows
    </Link>
</ul>
</nav>
        </div>

    );
}

export default NavBar;
